import comp from "./Graph";
export default comp;
